import {BUTTON_SIZE, IconButton} from '@time-webkit/all/atoms/icon-button';
import classNames from 'classnames';
import {forwardRef} from 'react';

import styles from './action-button.module.css';

type Props = React.ComponentProps<typeof IconButton> & {
    isActive?: boolean;
    buttonClassName?: string;
}

export const ActionButton = forwardRef<HTMLButtonElement, Props>((props, ref) => {
    const {
        buttonClassName,
        ...restProps
    } = props;

    return (
        <IconButton
            {...restProps}
            ref={ref}
            flat={true}
            className={classNames(styles.button, props.isActive && styles.isActiveBtn, buttonClassName)}
            size={BUTTON_SIZE.SMALL}
            focusRingClass={styles.focused}
        />
    );
});
